"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bgZones = void 0;
var bgZones = exports.bgZones = [];